import React from 'react';
import styles from './Blog.module.css';

const Blog = () => {
  return (
    <div className={styles.blogPage}>
      {/* Header */}
      <div className={styles.blogHeader}>
        <div className={styles.container}>
          <h1>Our <span className={styles.gradientText}>Blog</span></h1>
          <p>Insights, strategies, and updates from the world of Mathematics Optional preparation</p>
        </div>
        <div className={styles.headerWave}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120">
            <path fill="#EDFFF7" fillOpacity="1" d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"></path>
          </svg>
        </div>
      </div>

      <div className={styles.container}>
        <div className={styles.comingSoonCard}>
          <div className={styles.comingSoonContent}>
            <h2>It will be updated later</h2>
            <p>We are working on bringing you valuable content. Please check back soon.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;